<template>
    <div class="screen-cells">
        <div class="screen-cell">
            <div class="screen-options">
                <div
                    class="screen-option"
                    v-for="item in typeOptions"
                    :class="{
                        active: item.value === paramsData.parenttypecode,
                        'has-child': item.children && item.children.length
                    }"
                    @click="handleClick('parenttypecode', item)"
                    :key="item.value"
                >
                    {{ item.label }}
                </div>
            </div>
            <div
                ref="typeChildOptions"
                class="screen-child-options screen-options"
                :class="{
                    'has-toggle': showTypeChildtoggle,
                    opend: showTypeChildAll
                }"
                v-if="subTypeOptions.length"
            >
                <div
                    class="screen-option"
                    v-for="item in subTypeOptions"
                    :class="{
                        active: item.value == paramsData.typecode
                    }"
                    @click="handleClick('typecode', item)"
                    :key="item.value"
                >
                    {{ item.label }}
                </div>
                <div
                    v-show="showTypeChildtoggle"
                    class="child-type-toggle"
                    @click="showTypeChildAll = !showTypeChildAll"
                >
                    <span v-if="showTypeChildAll"> 收起 <i class="el-icon-arrow-up"></i> </span>
                    <span v-else> 展开全部{{ subTypeOptions.length }}项 <i class="el-icon-arrow-down"></i> </span>
                </div>
            </div>
        </div>
        <div class="screen-cell">
            <div class="screen-options">
                <div
                    class="screen-option"
                    v-for="item in pageSizeLimitOptions"
                    :class="{
                        active:
                            item.lower === paramsData.pagesize_lowerlimit &&
                            item.upper === paramsData.pagesize_upperlimit
                    }"
                    @click="handleClick('pageSizeLimit', item)"
                    :key="item.lower + '-' + item.upper"
                >
                    {{ item.label }}
                </div>
            </div>
        </div>
        <div class="screen-cell">
            <div class="screen-options">
                <div
                    class="screen-option"
                    v-for="item in orderOptions"
                    :class="{
                        active: item.value === paramsData.sortingrule
                    }"
                    @click="handleClick('sortingrule', item)"
                    :key="item.value"
                >
                    {{ item.label }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getMaterialTypesData } from '@/util/util';
export default {
    name: 'ScreenCells',
    props: {
        parenttypecode: {
            type: String,
            default: ''
        },
        typecode: {
            type: String,
            default: ''
        },
        sortingrule: {
            type: String,
            default: 'Comprehensiveness'
        }
    },
    data() {
        return {
            paramsData: {
                parenttypecode: '', // 父类别
                typecode: '', // 类别
                pagesize_lowerlimit: '', // 素材页数下限
                pagesize_upperlimit: '', // 素材页数上限
                sortingrule: 'Comprehensiveness' // 排序规则
            },
            typeOptions: [
                {
                    label: '全部',
                    value: ''
                }
            ],
            subTypeOptions: [],
            pageSizeLimitOptions: [
                {
                    label: '全部',
                    lower: '',
                    upper: ''
                },
                {
                    label: '1-100页',
                    lower: '1',
                    upper: '100'
                },
                {
                    label: '101-200页',
                    lower: '101',
                    upper: '200'
                },
                {
                    label: '201-300页',
                    lower: '201',
                    upper: '300'
                },
                {
                    label: '301-400页',
                    lower: '301',
                    upper: '400'
                },
                {
                    label: '401-500页',
                    lower: '401',
                    upper: '500'
                },
                {
                    label: '500页以上',
                    lower: '500',
                    upper: ''
                }
            ],
            orderOptions: [
                {
                    label: '综合',
                    value: 'Comprehensiveness'
                },
                {
                    label: '最新',
                    value: 'Latest'
                },
                {
                    label: '最热',
                    value: 'Hottest'
                }
            ],
            showTypeChildAll: false,
            showTypeChildtoggle: true,
            timer: null
        };
    },
    watch: {
        subTypeOptions() {
            this.handleTypeChildState();
        }
    },
    mounted() {
        this.paramsData.sortingrule = this.sortingrule || 'Comprehensiveness';
        this.getMaterialTypes();
        window.addEventListener('resize', () => {
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.handleTypeChildState();
            }, 300);
        });
    },
    destroyed() {
        window.removeEventListener('resize', () => {
            this.handleTypeChildState();
        });
    },
    methods: {
        handleClick(displayName, data) {
            if (displayName === 'pageSizeLimit') {
                this.paramsData.pagesize_lowerlimit = data.lower;
                this.paramsData.pagesize_upperlimit = data.upper;
            } else {
                this.paramsData[displayName] = data.value;
                if (displayName === 'parenttypecode') {
                    this.subTypeOptions = [];
                    console.log(data.children);
                    if (data.children && data.children.length) {
                        this.subTypeOptions = [
                            {
                                label: '全部',
                                value: this.paramsData.parenttypecode
                            }
                        ];
                        this.subTypeOptions = this.subTypeOptions.concat(data.children);
                        this.paramsData.typecode = this.subTypeOptions[0].value;
                        console.log(this.paramsData.typecode);
                    } else {
                        this.paramsData.typecode = '';
                    }
                }
            }
            this.change();
        },
        getMaterialTypes() {
            this.$Api.getMaterialTypes().then((data) => {
                this.typeOptions = this.typeOptions.concat(getMaterialTypesData(data));
                if (!this.parenttypecode && !this.typecode) {
                    this.paramsData.parenttypecode = '';
                    this.paramsData.typecode = '';
                } else if (this.parenttypecode) {
                    this.paramsData.parenttypecode = this.parenttypecode;
                    this.subTypeOptions = this.typeOptions.find((item) => item.value === this.parenttypecode).children;
                    if (this.typecode) {
                        this.paramsData.typecode = this.typecode;
                    } else {
                        this.paramsData.typecode = this.subTypeOptions[0].value;
                    }
                }
                this.change();
            });
        },
        change() {
            let params = {
                ...this.paramsData
            };
            delete params.parenttypecode;
            this.$emit('change', params);
        },
        handleTypeChildState() {
            this.showTypeChildAll = true;
            this.showTypeChildtoggle = false;
            this.$nextTick(() => {
                if (!this.$refs.typeChildOptions) {
                    return;
                }
                const rect = this.$refs.typeChildOptions.getBoundingClientRect();
                if (rect.height > 44) {
                    this.showTypeChildAll = false;
                    this.showTypeChildtoggle = true;
                } else {
                    this.showTypeChildAll = false;
                    this.showTypeChildAll = true;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/screen-cells.scss';
</style>
